import React from 'react'
import "./aboutMainBanner.css"
import AboutImage from "../../assets/aboutMain.jpg"

export default function AboutMainBanner() {
  return (
    <div>
        <div className="about-us" style={{ position: "relative" }}>
            <img className="about-home-image" alt="" src={AboutImage} />
          {/* <div class="aboutBannerparallax"></div> */}
          <div className="about-image-text-box">
            <div className="about-image-background-text">
              <h1 className="contact-image-topic">
                About Us
              </h1>
            </div>
          </div>
        </div>
    </div>
  )
}